import { Form } from 'components/ui/atoms';
import { getIsStripeCTAPending, useAppSelector } from 'store';
import { useStripeOptions } from 'frontastic/hooks';
import { AddressForm } from './address-form';
import { addressSchema } from './address-schema';
import { PlaceOrderButton } from './place-order-button';
import { StripeForm } from './stripe-form';
import { AddressSchema, CheckoutFormProps } from './types';

export const CheckoutForm = (props: CheckoutFormProps) => {
  const isStripeCTAPending = useAppSelector(getIsStripeCTAPending);

  const { placeStripeOrder } = useStripeOptions();

  const handleSubmit = (address: AddressSchema) => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    placeStripeOrder({ address, data: props });
  };

  return (
    <Form
      aria-label="checkout-form"
      onSubmit={handleSubmit}
      validationSchema={addressSchema}
      defaultValues={{
        firstName: '',
        lastName: '',
        address: '',
        unit: '',
        city: '',
        country: '',
        state: '',
        stateCode: 'not-required',
        postalCode: '',
      }}
    >
      <AddressForm isDisabled={isStripeCTAPending} />
      <StripeForm isDisabled={isStripeCTAPending} />
      <PlaceOrderButton isCTAPending={isStripeCTAPending} />
    </Form>
  );
};
